module.exports = __webpack_public_path__ + "static/media/03-speaker_profile.feff8571.webp";